import { render, staticRenderFns } from "./RzzxFx.vue?vue&type=template&id=4b912316&scoped=true&"
import script from "./RzzxFx.vue?vue&type=script&lang=js&"
export * from "./RzzxFx.vue?vue&type=script&lang=js&"
import style0 from "./RzzxFx.vue?vue&type=style&index=0&id=4b912316&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b912316",
  null
  
)

export default component.exports